<template>
  <div ref="lastArticlesHeader" class="lastArticlesContainer">
    <v-toolbar class="categoriesHeader" elevation="0"
    >
      <v-icon @click="goBack">
        mdi-chevron-left
      </v-icon>


      <v-toolbar-title class="pageTitle">
        Liefertage bearbeiten
      </v-toolbar-title>
    </v-toolbar>
    <v-divider class="headerDivider"/>
    <div class="contentWrapper checkoutContent" ref="contentWrapper" id="contentWrapper">
      <v-card class="stepperSearchWrapper">
        <v-container class="deliveryDays__container">
          <span>Kundenauswahl</span>

          <v-autocomplete class="searchCbx"
                        append-icon=""
                        outlined
                        dense
                        hide-details
                        placeholder="Kundenname..."
                        :items="customers"
                        chips
                        item-text="marketName"
                        item-value="id"
                        multiple
                        v-model="selectedCustomers"
                        no-data-text="Keine Eintrgäge gefunden..."
          >
            <template v-slot:selection="data">
              <v-chip
                  class="deliveryDays__chip-customer"
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  close
                  @click="data.select"
                  @click:close="removeCustomer(data.item)"
              >
                {{ data.item.marketName }}
              </v-chip>
            </template>
            <template v-slot:item="data">
              <template v-if="typeof data.item !== 'object'">
                <v-list-item-content v-text="data.item"></v-list-item-content>
              </template>
              <template v-else>
                <v-list-item-content>
                  <v-list-item-title v-html="data.item.marketName"></v-list-item-title>
                  <v-list-item-subtitle v-html="data.item.customerNo"></v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </template>

          </v-autocomplete>

          <span>Liefertage</span>
          <v-select class="searchCbx"
                      append-icon=""
                      outlined
                      dense
                      hide-details
                      placeholder="Lieferdatum eingeben..."
                      chips
                      multiple
                      v-model="overlappingExplicit"
                      :items="overlappingExplicit"
                      :rules="dateRules"
                      readonly
          >
            <template v-slot:selection="data">
              <v-chip
                  class="deliveryDays__chip-day"
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  close
                  @click="data.select"
                  @click:close="removeDate(data.item)"
              >
                {{ dateParse(data.item) }}
              </v-chip>
            </template>

            <template v-slot:append-outer>
              <v-dialog
                  ref="dialog"
                  v-model="modal"
                  :disabled="selectedCustomers.length < 1"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs"
                          v-on="on"
                          class="deliveryDays__chip-day-icon"
                  >
                    mdi-plus
                  </v-icon>
                </template>
                <v-date-picker
                    class="deliveryDatePicker"
                    locale="de"
                    :first-day-of-week="1"
                    multiple
                    v-model="date"
                    :selected-items-text="overlappingExplicit.length > 0 ? overlappingExplicit.length+' ausgewählt' : ''"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                      text
                      color="primary"
                      @click="modal = false"
                  >
                    Schließen
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </template>
          </v-select>
        </v-container>
      </v-card>
      <div class="bottomFiller"/>
    </div>
  </div>
</template>

<script>
import {mapMutations} from 'vuex'
import axios from 'axios'
import router from "@/router";

export default {
  name: "editDeliveryDaysCustomer",

  data() {
    return {
      isLoading: true,
      selectedCustomers: [],
      date: [],
      modal: false,

      dateRules: [
          v => /^\s*(3[01]|[12][0-9]|0?[1-9])\.(1[012]|0?[1-9])\.((?:19|20)\d{2})\s*$/.test(v)
      ],

      customers: [
      ],
    }
  },

  methods: {
    ...mapMutations({
      setHeaderVisibility: 'setHeaderVisibility'
    }),

    goBack() {
      router.go(-1)
    },

    dateParse(val) {
      let year = val.substring(0,4)
      let month = val.substring(5,7)
      let day = val.substring(8,10)

      return day+'.'+month+'.'+year
    },

    removeCustomer(item) {
      let index = 0
      for(let key in this.selectedCustomers) {
        if(key['id'] === item['id']) {
          return
        }
        index += index
      }
      if (index >= 0) this.selectedCustomers.splice(index, 1)
    },

    removeDate(item) {
      const index = this.date.indexOf(item)
      if (index >= 0) this.date.splice(index, 1)

      let selectedLength = this.selectedCustomers.length

      if(selectedLength > 0) {
        for(let i = 0; i < selectedLength; i++) {
          let index = this.customers[this.selectedCustomers[i] -1]['delivery_days']['explicitDays'].indexOf(item)
          this.customers[this.selectedCustomers[i] -1]['delivery_days']['explicitDays'].splice(index, 1)

          let params = {
            id: this.customers[this.selectedCustomers[i] -1]['delivery_days']['id'],
            explicitDays: this.customers[this.selectedCustomers[i] -1]['delivery_days']['explicitDays']
          }
          axios.post('api/updateDeliveryDays', params)
        }
      }
    },
  },

  computed: {
    overlappingExplicit() {
      let overlappingExplicit = []
      let selectedLength = this.selectedCustomers.length
      let explicitCustomer = this.customers

      if(selectedLength > 0) {
        for(let i = 0; i < selectedLength; i++) {
          if(overlappingExplicit.length === 0) {
            overlappingExplicit = explicitCustomer[this.selectedCustomers[i] -1 ]['delivery_days']['explicitDays']
          }
          else {
            overlappingExplicit = overlappingExplicit.filter(value => explicitCustomer[this.selectedCustomers[i] -1 ]['delivery_days']['explicitDays'].includes(value))
          }
        }
      }

      return overlappingExplicit
    }
  },

  created() {
    this.setHeaderVisibility(false)

    axios.get('api/getDeliveryDays')
    .then((response) => {



      response.data.forEach(function(item) {
        if(item.delivery_days === null) {
          return
        }
        else {
          item.delivery_days.explicitDays = JSON.parse(item.delivery_days.explicitDays)
        }
      })
      this.customers = response.data
      this.isLoading = false
    })
  },

  watch: {
    date: {
      handler(dates) {
        let selectedLength = this.selectedCustomers.length
        let datesLength = dates.length
        if(selectedLength > 0 && dates[0] !== undefined) {
          for(let i = 0; i < selectedLength; i++) {
            if(this.customers[this.selectedCustomers[i] -1]['delivery_days']['explicitDays'].indexOf(dates[datesLength -1]) === -1) {
              this.customers[this.selectedCustomers[i] -1]['delivery_days']['explicitDays'].push(dates[datesLength -1])

              let params = {
                id: this.customers[this.selectedCustomers[i] -1]['delivery_days']['id'],
                explicitDays: this.customers[this.selectedCustomers[i] -1]['delivery_days']['explicitDays']
              }
              axios.post('api/updateDeliveryDays', params)
            }
          }
        }
      }
    },

    selectedCustomers: {
      handler(customers) {

        let selectedLength = customers.length
        let datesLength = this.date.length

        if(selectedLength === 0) {
          this.date.length = 0
        }

        if(datesLength > 0 && selectedLength > 0) {
          for(let i = 0; i < selectedLength; i++) {
            for(let j= 0; j < datesLength; j++) {
              if(this.customers[customers[i] -1]['delivery_days']['explicitDays'].indexOf(this.date[j]) === -1) {
                this.customers[customers[i] - 1]['delivery_days']['explicitDays'].push(this.date[j])

                let params = {
                  id: this.customers[customers[i] -1]['delivery_days']['id'],
                  explicitDays: this.customers[customers[i] -1]['delivery_days']['explicitDays']
                }
                axios.post('api/updateDeliveryDays', params)
              }
            }
          }
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
